var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.5,
    r: 10,
    fill: "#28293D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F7",
    d: "M10 12.616c2.892 0 5.333.47 5.333 2.283 0 1.814-2.457 2.268-5.334 2.268-2.891 0-5.333-.47-5.333-2.284 0-1.814 2.457-2.267 5.333-2.267Zm0-8.783c1.959 0 3.529 1.57 3.529 3.528a3.516 3.516 0 0 1-3.53 3.528A3.517 3.517 0 0 1 6.47 7.36 3.516 3.516 0 0 1 10 3.833Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5ebef725a6d4d6bf5df035fa9dbe2941.svg";
export { ForwardRef as ReactComponent };